import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
	StyledContainer,
	StyledLargeBlock,
	StyledTopLeftButtons,
	StyledTopRightButtons,
} from './index.styled';

const CalendarSkeleton = () => (
	<StyledContainer>
		<StyledTopLeftButtons>
			<Skeleton width={210} height={40} />
		</StyledTopLeftButtons>
		<StyledTopRightButtons>
			<Skeleton width={210} height={40} />
		</StyledTopRightButtons>
		<Skeleton width={1050} height={40} />
		<StyledLargeBlock>
			<Skeleton height={400} />
		</StyledLargeBlock>
	</StyledContainer>
);

export default CalendarSkeleton;
